<template>
  <div class="shortcut">
    <Header title="快捷入口" />
    <div class="shortcut__content" flex="dir:top main:justify">
      <div>
        <el-button type="warning" size="small"  style="margin:10px 0 0 20px"    v-if="dl_type=='-1'" @click="$router.replace({ path: '/system/oneagent' })">新增一级代理</el-button>
        <el-button type="warning" size="small"  style="margin:10px 0 0 20px"    v-if="dl_type=='0'" @click="$router.replace({ path: '/system/twoagent' })">新增二级代理</el-button>
        <el-button type="warning" size="small"  style="margin:10px 0 0 20px"    v-if="dl_type=='1'" @click="$router.replace({ path: '/system/threeagent' })">新增三级代理</el-button>
        <el-button type="warning" size="small"  style="margin:10px 0 0 20px"    v-if="agentid==''" @click="$router.replace({ path: '/system/agent' })">新增大OEM代理商</el-button>
      </div>
      <div>
        <el-button type="primary" size="small" style="margin:10px 0 0 20px"  @click="$router.replace({ path: '/system/shops' })">新增商家</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../Header'
import util from '@/libs/util.js'
export default {
  components: { Header },
  name: 'Notice',

  data () {
    return {
      agentid: util.cookies.get('agentid'),
      dl_type: util.cookies.get('dl_type')

    }
  },

  created () {}
}
</script>

<style lang="scss" scoped>
.shortcut {
  width: 100%;
  border-radius: 10px;
  height: 1.4rem;
  min-height: 130px;
  &__row {
  }
}
</style>
